module.exports = __webpack_public_path__ + "img/Nudg-logo.66bedda7.svg";